/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: a6cc95890d14
 */

import * as z from "zod";

export type Folder = {
  name: string;
  path: string;
  external_id: string;
  created_at?: string | undefined;
};

export const Folder$zodSchema: z.ZodType<Folder> = z.object({
  created_at: z.iso.datetime({ offset: true }).optional().describe(
    "The timestamp when the folder was created.",
  ),
  external_id: z.string().describe("The unique identifier for the folder."),
  name: z.string().describe("The name of the folder."),
  path: z.string().describe("The full path of the folder."),
});
